export enum TimesheetStatus {
	Active = 'Active',
	Submitted = 'Submitted',
	Approved = 'Approved',
	Archived = 'Archived',
}
export enum MultiStageStatus {
	PreApproved = 'Pre Approved',
}
